module.exports = __webpack_public_path__ + "media/prk/assets/images/icons/buildings-gray-e3fbfdd54c3900923ab0d4053a31a035.svg";